import { lazy } from 'react';
const Sections = lazy(() => import('./pages/sections/Sections.jsx'));

const  Facilities = lazy(() => import('./pages/facilities/Facilities'));
const  CompanyUsers = lazy(() => import('./pages/companyUsers/CompanyUsers.jsx'));
const  Support = lazy(() => import('./pages/support/Support.jsx'));
const  Companies = lazy(() => import('./pages/companies/Companies.jsx'));
const  Technicians = lazy(() => import('./pages/technician/Technicians.jsx'));
const  Devices = lazy(() => import('./pages/devices/Devices.jsx'));
const  Users = lazy(() => import('./pages/users/Users.jsx'));
const  Requests = lazy(() => import('./pages/requests/Requests.jsx'));
const  ActivityLog = lazy(() => import('./pages/activityLog/ActivityLog.jsx'));
const  Dashboard = lazy(() => import('./pages/dashboard/Dashboard.jsx'));
const  LorawanDevice = lazy(() => import('./pages/lorawanDevices/LorawanDevice.jsx'));
const  Gateway = lazy(() => import('./pages/Gateways/Gateway.jsx'));

export const baseUrl = "https://iotplatform.sanarapida.com";
//export const baseUrl = "http://192.168.18.19:443";
export const apiPath = `${baseUrl}/api/v1`;

export const menuOptions = [
  {id : 1, path: '/dashboard', label:'Dashboard', iconType: "fa", icon: "fa-home", roles:[1,2,3,4], comp: Dashboard},
  {id : 2, path: '/companies', label:'Companies', iconType: "fa", icon: "ri-building-line", roles:[1], comp: Companies},
  {id : 3, path: '/technicians', label:'Technician', iconType: "fa", icon: "ri-tools-line", roles:[1], comp: Technicians},
  {id : 4, path: '/facilities', label:'Facilities', iconType: "fa", icon: "ri-building-4-line", roles:[1,2,3,4], comp: Facilities},
  {id : 5, path: '/devices', label:'Logo', iconType: "fa", icon: "fa-laptop", roles:[1], comp: Devices},
  {id : 10, path: '/users', label:'Users', iconType: "fa", icon: "ri-group-line", roles:[1,2], comp: Users},
  {id : 11, path: '/requests', label:'Requests', iconType: "fa", icon: "ri-mail-line", roles:[1], comp: Requests},
  {id : 9, path: '/support', label:'Support', iconType: "fa", icon: "fa-comments", roles:[2,3,4], comp: Support},
  {id : 8, path: '/activity-log', label:'Activity log', iconType: "fa", icon: "ri-history-line", roles:[1], comp: ActivityLog},
  {id : 12, path: '/lorawandevices', label:'Lorawan', iconType: "fa", icon: "fa-laptop", roles:[1], comp: LorawanDevice},
  {id : 13, path: '/gateways', label:'Gateways', iconType: "fa", icon: "ri-building-4-line", roles:[1], comp: Gateway},
  {id : 14, path: '/sections', label:'Sections', iconType: "fa", icon: "fa-code-fork", roles:[1], comp: Sections},
];